<template>
  <!-- receipting modal -->
  <div aria-hidden="true" aria-labelledby="myLargeModalLabel" class="modal fade receipting-modal"
       role="dialog"
       tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-full modal-fullscreen">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myLargeModalLabel">{{businessDetails.businessName}} Business Details</h5>
          <span
              class="badge rounded-pill bg-warning text-uppercase font-12px text-uppercase mx-3 text-dark">Pending Invoicing For {{invoicingYear}}</span>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <!-- Loading Overlay -->
        <div v-if="isDataLoading" class="modal-body position-relative">
          <div class="d-flex flex-column align-items-center justify-content-center py-5">
            <div class="spinner-border text-primary mb-3" style="width: 3rem; height: 3rem;" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <h5 class="text-primary mb-2">Fetching Business Information...</h5>
            <p class="text-muted mb-0">Please wait while we load the business details, categories, and fee structures.</p>
          </div>

          <!-- Skeleton Loading Preview -->
          <div class="row mt-4 opacity-50">
            <div class="col-md-4">
              <div class="card">
                <div class="card-body">
                  <div class="placeholder-glow">
                    <span class="placeholder col-6 mb-2"></span>
                    <span class="placeholder col-8 mb-2"></span>
                    <span class="placeholder col-7 mb-2"></span>
                    <span class="placeholder col-9 mb-2"></span>
                    <span class="placeholder col-5 mb-2"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card">
                <div class="card-body">
                  <div class="placeholder-glow">
                    <span class="placeholder col-7 mb-2"></span>
                    <span class="placeholder col-6 mb-2"></span>
                    <span class="placeholder col-8 mb-2"></span>
                    <span class="placeholder col-5 mb-2"></span>
                    <span class="placeholder col-9 mb-2"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card">
                <div class="card-body">
                  <div class="placeholder-glow">
                    <span class="placeholder col-8 mb-2"></span>
                    <span class="placeholder col-6 mb-2"></span>
                    <span class="placeholder col-7 mb-2"></span>
                    <span class="placeholder col-9 mb-2"></span>
                    <span class="placeholder col-4 mb-2"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Actual Content (shown when data is loaded) -->
        <div v-else class="modal-body">
          <div class="row">

            <div class="col-sm-12 col-md-4">
              <div class="row">
                <div class="col-12 mt-4">
                  <div class="bg-info border-2 bg-soft p-2 mb-4 d-flex align-items-center">
                    <i class="bx bx-briefcase-alt-2 font-28 mr-15px"></i>
                    <p class="fw-semibold mb-0 pb-0">Business Details </p>

                  </div>
                </div>
                <div class="col-12">
                  <div class="table-responsive">
                    <table
                        class="table table-nowrap vertical-align-middle table-striped table-sm">
                      <thead class="table-light">
                      <th colspan="3" class="text-right text-uppercase">Verification Status <br> <a href="javascript: void(0);">(By {{businessDetails.createdBy}})</a></th>
                      </thead>
                      <tbody>
                      <tr
                          title="">
                        <td>
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            Business
                            Name</p>
                        </td>
                        <td class="">
                          <input v-model="localBusinessDetails.businessName" type="text" class="form-control form-control-sm" placeholder="Enter Business Name">
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            Sub County</p>
                        </td>
                        <td class="">
                          <select class="form-select form-select-sm" id="country" fdprocessedid="fw9x5" @change="onSubCountyChange(localSubCounty.subCountyID)" v-model="localSubCounty">
                            <option v-for="(item, index) in subCounties" :key="`${index}`" :value="item"><a class="dropdown-item" href="javascript: void(0);">{{item.subCountyName}}</a></option>
                          </select>

                        </td>

                      </tr>

                      <tr
                          title="Driving Without identification plates affixed or plates not fixed in the prescribed manner">
                        <td>
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            Ward </p>
                        </td>
                        <td class="">
                          <select class="form-select form-select-sm" fdprocessedid="fw9x5" v-model="localWard" >
                            <option :key="`${index}`" :value="item" v-for="(item, index) in wards">
                              class="dropdown-item" href="javascript: void(0);">{{item.wardName}}</option>
                          </select>

                        </td>

                      </tr>

                      <tr
                          title="Driving Without identification plates affixed or plates not fixed in the prescribed manner">
                        <td>
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            Zone</p>
                        </td>
                        <td class="">

                          <select class="form-select form-select-sm" fdprocessedid="fw9x5" v-model="localZone">
                            <option v-for="(item, index) in zones" :key="`${index}`"><a class="dropdown-item" href="javascript: void(0);">{{item.zone}}</a></option>
                          </select>


                        </td>

                      </tr>

                      <tr>
                        <td>
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Plot No.</p>

                        </td>
                        <td class="">
                          <input v-model="localBusinessDetails.plotNumber" type="text" class="form-control form-control-sm" placeholder="Plot Number">
                        </td>


                      </tr>
                      <tr>
                        <td>
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">VAT
                            No.
                          </p>

                        </td>
                        <td class="">
                          <input v-model="localBusinessDetails.kraPin" type="text" class="form-control form-control-sm" placeholder="Enter VAT NO.">
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Physical Address
                          </p>

                        </td>
                        <td class="">
                          <input v-model="localBusinessDetails.physicalAddress" type="text" class="form-control form-control-sm" placeholder="Enter The ADdress" value="Next to Kianjokoma Market">
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Building Name
                          </p>

                        </td>
                        <td class="">
                          <input v-model="localBusinessDetails.buildingName" type="text" class="form-control form-control-sm" placeholder="Enter The Building Name" value="The Tower">
                        </td>
                      </tr>
                      <tr
                          title="Driving Without identification plates affixed or plates not fixed in the prescribed manner">
                        <td>
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            Floor Number</p>
                        </td>
                        <td class="">
                          <select class="form-select form-select-sm" fdprocessedid="fw9x5" v-model="localFloor">
                            <option v-for="(item, index) in floors" :key="`${index}`"><a class="dropdown-item" href="javascript: void(0);">{{item.floor}}</a></option>
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Stall/Room No.
                          </p>

                        </td>
                        <td class="">
                          <input v-model="localBusinessDetails.roomNo" type="text" class="form-control form-control-sm" placeholder="Enter No. if Applicable" value="NA">
                        </td>
                      </tr>

                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="col-12">
                  <div class="table-responsive">
                    <table
                        class="table table-nowrap vertical-align-middle table-striped table-sm">
                      <thead class="table-warning">
                      <th colspan="3" class="text-uppercase ">
                        <div class="justify-content-between d-flex">
                          <div>
                            {{entry.year}} Invoicing Details
                          </div>
                          <div>
                            <a @click="onPrintBill(entry.billNo)" href="javascript: void(0);" target="new" class="btn btn-primary btn-sm text-uppercase">Open</a>
                          </div>
                        </div>
                      </th>
                      </thead>
                      <tbody>
                      <tr class=" fw-semibold text-uppercase">
                        <td class="text-primary">
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            Invoice No.</p>

                        </td>

                        <td class=""><span class="text-primary">{{billDetail.billNo}}</span></td>

                      </tr>
                      <tr class=" fw-semibold text-uppercase">
                        <td class="text-primary">
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            Total Invoiced Amount</p>

                        </td>
                        <td class=""><span class="text-primary"></span> <span class="text-primary">KES {{numberFormat(billDetail.detailAmount)}}</span></td>

                      </tr>
                      <tr class=" fw-semibold text-uppercase">
                        <td class="text-primary">
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            Amount Paid</p>
                        </td>
                        <td class=""><span class="text-primary"></span> <span class="text-primary">KES {{numberFormat(billDetail.receiptAmount)}}</span></td>

                      </tr>

                      <tr class=" fw-semibold text-uppercase">
                        <td class="text-primary">
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            Outstanding Balance</p>
                        </td>
                        <td class=""><span class="text-primary"></span> <span class="text-primary">KES {{numberFormat(billDetail.billBalance)}}</span></td>

                      </tr>

                      <tr class=" fw-semibold text-uppercase">
                        <td class="text-primary">
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            Invoiced By</p>
                        </td>
                        <td class=""><span class="text-primary"></span> <span class="text-primary">{{billDetail.names}} on {{formattedDate(billDetail.dateCreated)}}</span></td>

                      </tr>

                      <tr class=" fw-semibold text-uppercase">
                        <td class="text-primary">
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            Inspected By</p>
                        </td>
                        <td class="">
                          <span class="text-primary"></span>
                          <!-- Safely check if statuses[3] exists -->
                          <span v-if="statuses[3]" class="text-primary">{{ statuses[3].issuingOfficer || 'Unknown Officer' }} on{{ formattedDate(statuses[3].dateCreated) || 'Unknown Date' }}</span>
                        </td>
                      </tr>

                      <tr class=" fw-semibold text-uppercase">
                        <td class="text-primary">
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            Current Stage ({{entry.status}})</p>
                        </td>
                        <td class=""><span class="text-primary"></span> <span class="text-primary">{{entry.stageStatus}}</span></td>

                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-12 col-md-4">
              <div class="row">
                <div class="col-12 mt-4">
                  <div class="bg-warning border-2 bg-soft p-2 mb-4 d-flex align-items-center">
                    <i class="bx bxs-user-pin font-28 mr-15px"></i>
                    <p class="fw-semibold mb-0 pb-0">Ownership and Business's Contact information</p>

                  </div>
                </div>
                <div class="col-12">
                  <div class="table-responsive">
                    <table
                        class="table table-nowrap vertical-align-middle table-striped table-sm">
                      <thead class="table-light">
                      <th colspan="3" class="text-uppercase">Owner Details</th>
                      </thead>
                      <tbody>
                      <tr
                          title="Driving Without identification plates affixed or plates not fixed in the prescribed manner">
                        <td>
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            Full Names</p>
                        </td>
                        <td class="">
                          <input v-model="localBusinessDetails.fullNames" type="text" class="form-control form-control-sm" placeholder="Owner's full names">
                        </td>

                      </tr>

                      <tr
                          title="Driving Without identification plates affixed or plates not fixed in the prescribed manner">
                        <td>
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            Owner's ID</p>
                        </td>
                        <td class="">
                          <input v-model="localBusinessDetails.ownerID" type="text" class="form-control form-control-sm" placeholder="Owner's ID Number">
                        </td>
                      </tr>

                      <tr
                          title="Driving Without identification plates affixed or plates not fixed in the prescribed manner">
                        <td>
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            Owner's Phone No.</p>
                        </td>
                        <td class="">
                          <input v-model="localBusinessDetails.ownerPhone" type="text" class="form-control form-control-sm" placeholder="Owner's Phone No.">
                        </td>

                      </tr>

                      <tr>
                        <td>
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            Email Address</p>

                        </td>
                        <td class="">
                          <input v-model="localBusinessDetails.ownerEmail" type="text" class="form-control form-control-sm" placeholder="Enter Email">
                        </td>

                      </tr>

                      <tr>
                        <td>
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            KRA PIN No. (Optional)</p>

                        </td>
                        <td class="">
                          <input type="text" class="form-control form-control-sm" placeholder="Enter KRA Pin Number" >
                        </td>

                      </tr>

                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="col-12">
                  <div class="table-responsive">
                    <table
                        class="table table-nowrap vertical-align-middle table-striped table-sm">
                      <thead class="table-light">
                      <th colspan="3" class="text-uppercase">Business Contact Information</th>
                      </thead>
                      <tbody>

                      <tr
                          title="Driving Without identification plates affixed or plates not fixed in the prescribed manner">
                        <td>
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            Owner's Phone No.</p>
                        </td>
                        <td class="">
                          <input v-model="localBusinessDetails.contactPersonPhone" type="text" class="form-control form-control-sm" placeholder="Owner's Phone No.">
                        </td>

                      </tr>

                      <tr>
                        <td>
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            Business's Email Address</p>

                        </td>
                        <td class="">
                          <input v-model="localBusinessDetails.contactPersonEmail" type="text" class="form-control form-control-sm" placeholder="Enter Email">
                        </td>

                      </tr>
                      <tr>
                        <td>
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            Postal Address</p>

                        </td>
                        <td class="">
                          <input v-model="localBusinessDetails.postalAddress" type="text" class="form-control form-control-sm" placeholder="Enter Postal ADress">
                        </td>

                      </tr>

                      <tr>
                        <td>
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            Company Phone Number</p>

                        </td>
                        <td class="">
                          <input v-model="localBusinessDetails.businessPhone" type="text" class="form-control form-control-sm" placeholder="Enter Postal ADress">
                        </td>

                      </tr>


                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="col-12">
                  <div class="table-responsive">
                    <table
                        class="table table-nowrap vertical-align-middle table-striped table-sm">
                      <thead class="table-light">
                      <th colspan="3" class="text-uppercase">Contact Person</th>
                      </thead>
                      <tbody>

                      <tr
                          title="Driving Without identification plates affixed or plates not fixed in the prescribed manner">
                        <td>
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            Full Names</p>
                        </td>
                        <td class="">
                          <input v-model="localBusinessDetails.contactPersonNames" type="text" class="form-control form-control-sm" placeholder="Owner's Phone No.">
                        </td>

                      </tr>

                      <tr>
                        <td>
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            ID Number</p>

                        </td>
                        <td class="">
                          <input v-model="localBusinessDetails.contactPersonIDNo" type="text" class="form-control form-control-sm" placeholder="ID Number">
                        </td>

                      </tr>
                      <tr>
                        <td>
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            Contact Person's Role</p>

                        </td>
                        <td class="">
                          <input v-model="localBusinessDetails.businessRole" type="text" class="form-control form-control-sm" placeholder="Enter Postal ADress">
                        </td>

                      </tr>

                      <tr>
                        <td>
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            Contact Person's Phone Number</p>

                        </td>
                        <td class="">
                          <input v-model="localBusinessDetails.contactPersonPhone" type="text" class="form-control form-control-sm" placeholder="Enter Postal ADress">
                        </td>

                      </tr>


                      </tbody>
                    </table>
                  </div>
                </div>
              </div>


            </div>

            <div class="col-sm-12 col-md-4">
              <div class="row">
                <div class="col-12 mt-4">
                  <div class="bg-danger border-2 bg-soft p-2 mb-4 d-flex align-items-center rounded">
                    <i class="bx bxs-wallet font-28 mr-15px"></i>
                    <p class="fw-bold mb-0 ">Billing and Business Categorization Details</p>
                  </div>
                </div>


                <div class="col-12">
                  <div class="table-responsive">
                    <table
                        class="table table-nowrap vertical-align-middle table-striped table-sm">
                      <thead class="table-light">
                      <th colspan="3" class="text-uppercase">SBP Categorization Fees</th>
                      </thead>
                      <tbody>
                      <tr
                          title="Driving Without identification plates affixed or plates not fixed in the prescribed manner">
                        <td>
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            Category</p>
                        </td>
                        <td class="">
                          <select class="form-select form-select-sm" fdprocessedid="fw9x5" @change="onTradeCategoryChange(localTradeCategory.incomeTypeId)" v-model="localTradeCategory">
                            <option v-for="(item, index) in tradeCategories" :key="`${index}`" :value="item"><a class="dropdown-item" href="javascript: void(0);">{{item.incomeTypeDescription}}</a></option>
                          </select>


                        </td>
                      </tr>

                      <tr
                          title="Driving Without identification plates affixed or plates not fixed in the prescribed manner">
                        <td>
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            Sub category</p>
                        </td>
                        <td class="">

                          <select class="form-select form-select-sm" fdprocessedid="fw9x5" v-model="localTradeSubCategory">
                            <option v-for="(item, index) in tradeSubCategories" :key="`${index}`" :value="item"><a class="dropdown-item" href="javascript: void(0);">{{item.feeDescription}}  KES {{numberFormat(item.unitFeeAmount)}}</a></option>
                          </select>

                        </td>
                      </tr>

                      <tr title="Driving Without identification plates affixed or plates not fixed in the prescribed manner">
                        <td>
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            Business Activity</p>
                        </td>
                        <td class="">
                          <input v-model="localBusinessDetails.businessDes" type="text" class="form-control form-control-sm" placeholder="Owner's full names" spellcheck="false" data-ms-editor="true">
                        </td>

                      </tr>


                      <tr
                          title="Driving Without identification plates affixed or plates not fixed in the prescribed manner">
                        <td>
                          <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">
                            SBP Charges</p>
                        </td>

                        <td class="text-right">
                          <h4 class="text-primary fs-4 mb-0 fw-bold"> KES  {{numberFormat(localTradeSubCategory.unitFeeAmount)}}</h4>
                        </td>

                      </tr>

                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="col-12">
                  <div class="table-responsive">
                    <table
                        class="table table-nowrap vertical-align-middle table-bordered table-sm">
                      <thead class="table-info">
                      <tr class="text-uppercase table-info">
                        <th colspan="">
                          Other Applicable Charges <i>(-- Select Where Applicable. --)</i>
                        </th>
                      </tr>
                      </thead>
                      <tbody>

                      <tr v-for="(item, index) in tradeSubCategoriesOther" :key="index">
                        <td>
                          <div class="form-check form-check-primary mb-0">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                :id="'formCheckcolor' + index"
                                v-model="localCheckedItems"
                                :value="item"
                            >
                            <label class="form-check-label" :for="'formCheckcolor' + index">
                              {{ item.feeDescription }} - <strong>KES {{ numberFormat(item.unitFeeAmount) }}</strong>
                            </label>
                          </div>
                        </td>
                      </tr>



                      </tbody>
                      <tfoot class="table-success">
                      <tr>
                        <th class="text-uppercase">Total({{numberFormat(localCheckedItems.length)}}) KES {{numberFormat(computedTotalFeeAmount)}}</th>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

                <!-- penalizing -->
                <div class="col-12">
                  <div class="table-responsive">
                    <table
                        class="table table-nowrap vertical-align-middle table-bordered table-sm">
                      <thead class="table-info">
                      <tr class="text-uppercase table-info">
                        <th colspan="">
                          Business Penalties <i>(-- Select Where Applicable. --)</i>
                        </th>
                      </tr>
                      </thead>
                      <tbody>

                      <tr>
                        <td>
                          <div class="form-check form-check-primary mb-0">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="localPenalized"
                            >
                            <label class="form-check-label">
                              Penalty
                            </label>
                          </div>
                        </td>
                      </tr>



                      </tbody>
                      <tfoot class="table-success">
                      <tr>
                        <th class="text-uppercase">Penalty Charges </th>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>


                <!-- for a downgrade show this -->

                <div v-if="Number(entry.billTotal) > Number(localTradeSubCategory.unitFeeAmount)" class="col-12">
                  <div class="card bg-danger text-white-50">
                    <div class="card-body">
                      <h5 class="mb-4 text-white text-uppercase"><i class="mdi mdi-block-helper me-3"></i> SBP License Fee Adjustment Notification</h5>
                      <p class="card-text">Please be informed that the SBP license fee for {{invoicingYear}} will be reduced by KES {{numberFormat(Number(entry.billTotal)-Number(localTradeSubCategory.unitFeeAmount))}} compared to the {{entry.year}} fee.</p>
                    </div>
                  </div>
                  <div class="alert alert-warning border-1 border-warning" role="alert">
                    <h4 class="text-uppercase fw-bold mb-0">Previous Amount ({{entry.year}}): <strong class="text-primary">KES {{numberFormat(entry.billTotal)}}</strong></h4>
                    <p class="mb-0 text-black">Subcategory: {{entry.feeDescription}}</p>
                  </div>

                  <div class="alert alert-danger border-1 border-danger" role="alert">
                    <h4 class="text-uppercase fw-bold mb-0">New Amount ({{invoicingYear}}): <strong class="text-danger">KES {{numberFormat(localTradeSubCategory.unitFeeAmount)}}</strong></h4>
                    <p class="mb-0 text-black">Subcategory: {{localTradeSubCategory.feeDescription}}</p>
                  </div>
                </div>

                <!-- for maintained  -->
                <div v-if="Number(entry.billTotal) === Number(localTradeSubCategory.unitFeeAmount)" class="col-12">
                  <div class="card bg-primary text-white-50">
                    <div class="card-body">
                      <h5 class="mb-4 text-white text-uppercase"><i class="mdi mdi-information-outline me-3"></i> SBP License Fee Update</h5>
                      <p class="card-text text-capitalize">Please note that the SBP license fee for {{invoicingYear}} remains the same as in {{entry.year}}, the amounts charged also remain the same.</p>
                    </div>
                  </div>

                  <div class="alert alert-info border-1 border-info" role="alert">
                    <h4 class="text-uppercase fw-bold mb-0">Amount ({{entry.year}}): <strong class="text-primary">KES {{numberFormat(entry.billTotal)}}</strong></h4>
                    <p class="mb-0 text-black">Previous Subcategory: {{entry.feeDescription}}</p>
                  </div>

                  <div class="alert alert-info border-1 border-info" role="alert">
                    <h4 class="text-uppercase fw-bold mb-0">Amount ({{invoicingYear}}): <strong class="text-primary">KES {{numberFormat(localTradeSubCategory.unitFeeAmount)}}</strong></h4>
                    <p class="mb-0 text-black">Current Subcategory: {{localTradeSubCategory.feeDescription}}</p>
                  </div>
                </div>

                <!-- for uphraded business -->
                <div v-if="Number(entry.billTotal) < Number(localTradeSubCategory.unitFeeAmount)" class="col-12">
                  <div class="card bg-success text-white-50">
                    <div class="card-body">
                      <h5 class="mb-4 text-white text-uppercase"><i class="mdi mdi-star-circle-outline me-3"></i> Congratulations on Your Business Upgrade!</h5>
                      <p class="card-text">We're excited to inform you that the business has been upgraded to a higher category for {{invoicingYear}}. This enhancement reflects the growth and success of the business, with an adjusted license fee to match the new category.</p>
                    </div>
                  </div>

                  <div class="alert alert-info border-1 border-info" role="alert">
                    <h4 class="text-uppercase fw-bold mb-0">Previous Amount ({{entry.year}}): <strong class="text-primary">KES {{numberFormat(entry.billTotal)}}</strong></h4>
                    <p class="mb-0 text-black">Previous Subcategory: {{entry.feeDescription}}</p>
                  </div>

                  <div class="alert alert-success border-1 border-success" role="alert">
                    <h4 class="text-uppercase fw-bold mb-0">New Amount ({{invoicingYear}}): <strong class="text-success">KES {{numberFormat(localTradeSubCategory.unitFeeAmount)}}</strong></h4>
                    <p class="mb-0 text-black">New Subcategory: {{localTradeSubCategory.feeDescription}}</p>
                  </div>
                </div>


              </div>


            </div>

            <div class="col-sm-12 col-md-8">
              <div class="row">
                <div class="col-12 mt-4">
                  <div class="bg-dark border-2 bg-soft p-2 mb-4 d-flex align-items-center">
                    <i class="bx bx-map font-28 mr-15px"></i>
                    <p class="fw-semibold mb-0 pb-0">Map View</p>

                  </div>
                </div>
                <div class="col-12">
                  <div>
                    <iframe
                        :src="mapUrl"
                        width="100%"
                        height="450"
                        style="border:0;"
                        allowfullscreen
                        loading="lazy"
                        referrerpolicy="no-referrer-when-downgrade">
                    </iframe>
                  </div>
                </div>
              </div>


            </div>

            <div class="col-sm-12 col-md-4">
              <div class="row">
                <div class="col-12 mt-4">
                  <div class="bg-danger border-2 bg-soft p-2 mb-4 d-flex align-items-center">
                    <i class="bx bxs-edit-alt pin font-28 mr-15px"></i>
                    <p class="fw-semibold mb-0 pb-0">SBP {{invoicingYear}} Licensing Actions</p>

                  </div>
                </div>

                <div class="col-12">
                  <h4 class="card-title">Validation actions</h4>
                </div>


                <div class="col-6">
                  <div class="form-check mb-3">
                    <input v-model="localValidationAction" class="form-check-input" type="radio" name="radioValidation" id="formRadios-validate" value="approve">
                    <label class="form-check-label" for="formRadios-validate">
                      Approve For Invoicing.
                    </label>
                  </div>
                </div>

                <div class="col-6">
                  <div class="form-check mb-3 form-radio-danger">
                    <input v-model="localValidationAction" class="form-check-input" type="radio" name="radioValidation" id="formRadios-archive" value="archive">
                    <label class="form-check-label" for="formRadios-archive">
                      Archive Business
                    </label>
                  </div>
                </div>

                <div v-if="localValidationAction==='archive'" class="col-12 archived-details">
                  <div class="mb-2">
                    <label for="archive_reason">Reason for Archiving:</label>
                    <select v-model="localArchiveReason" name="archive_reason" id="archive_reason" class="form-select">
                      <option value="" disabled selected>Select a reason</option>
                      <option value="Duplicate Record">Duplicate Record</option>
                      <option value="Business Closed">Business Closed</option>
                      <option value="Test Data">Test Data</option>
                      <option value="Data Obsolete">Data Obsolete</option>
                      <option value="Merged with Another Business">Merged with Another Business</option>
                      <option value="Invalid/Incomplete Details">Invalid/Incomplete Details</option>
                      <option value="Ownership Change">Ownership Change</option>
                      <option value="No Longer Operational">No Longer Operational</option>
                      <option value="Moved to a Different Location">Moved to a Different Location</option>
                      <option value="Compliance Issues">Compliance Issues</option>
                      <option value="Requested by Owner">Requested by Owner</option>
                      <option value="Record Created in Error">Record Created in Error</option>
                      <option value="Redundant Entry">Redundant Entry</option>
                      <option value="other">Other Reason</option>
                    </select>

                  </div>

                  <div v-if="localArchiveReason ==='other'" class="mb-2 other-reason-cont">
                    <label for="">Enter other Reason</label>
                    <input v-model="localOtherReason" type="" class="form-control" placeholder="Enter other reason" name="" value="">
                  </div>


                  <div>
                    <button @click="onArchive()" class="btn btn-danger justify-content-center text-uppercase d-flex align-items-center archive-record w-100 text-center" title="Archive this business record">
                      <i class="bx bx-archive me-2"></i>
                      <div>Archive Record</div>
                      <div v-if="loading" class="spinner-border text-white ms-2" style="height: 19px; width: 19px;" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </button>
                  </div>

                </div>

                <div v-if="localValidationAction==='approve'" class="col-12 approved-details">
                  <div>
                    <div class="d-flex flex-column">
                      <label class="">Remarks (If Any)</label>
                    </div>
                    <textarea v-model="localRemarks" name="" id="" cols="30" rows="3" class="form-control mb-3" placeholder="Enter your Remarks"></textarea>
                  </div>

                  <!-- NEW: Two button options -->
                  <div class="row">
                    <!-- UPDATE ONLY BUTTON -->
                    <div class="col-6 mb-2">
                      <button
                          @click="onUpdateOnly()"
                          class="btn btn-warning justify-content-center text-uppercase d-flex align-items-center w-100 text-center"
                          title="Update business info for later bulk invoicing"
                          :disabled="isDataLoading || !isDataReady"
                      >
                        <i class="bx bx-save me-2"></i>
                        <div>Update Only</div>
                        <div v-if="loadingUpdate" class="spinner-border text-dark ms-2" style="height: 19px; width: 19px;" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </button>
                      <small class="text-muted d-block text-center mt-1">Save for bulk invoicing later</small>
                    </div>

                    <!-- GENERATE INVOICE BUTTON -->
                    <div class="col-6 mb-2">
                      <button
                          @click="onGenerateInvoice()"
                          class="btn btn-success justify-content-center text-uppercase d-flex align-items-center w-100 text-center"
                          title="Update and generate invoice now"
                          :disabled="isDataLoading || !isDataReady"
                      >
                        <i class="bx bx-receipt me-2"></i>
                        <div>Generate Invoice</div>
                        <div v-if="loadingInvoice" class="spinner-border text-white ms-2" style="height: 19px; width: 19px;" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </button>
                      <small class="text-muted d-block text-center mt-1">Update & create invoice now</small>
                    </div>
                  </div>

                  <!-- Total Amount Summary -->
                  <div class="alert alert-primary mt-3 mb-0">
                    <div class="d-flex justify-content-between align-items-center">
                      <span class="fw-bold">Total Amount ({{invoicingYear}}):</span>
                      <span class="fw-bold fs-5">KES {{ numberFormat(computedGrandTotal) }}</span>
                    </div>
                    <small class="text-muted">Main Fee: KES {{ numberFormat(localTradeSubCategory.unitFeeAmount) }} + Additional: KES {{ numberFormat(computedTotalFeeAmount) }}</small>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
        <div class="modal-footer d-none">

          <a @click="onPrintReceipt" href="javascript: void(0);" target="_blank" type="button"
             class="btn btn-primary waves-effect waves-light">
            <i class="mdi mdi-printer font-size-16 align-middle me-2"></i> Print Receipt
          </a>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- end of receipting modal -->
</template>

<script>
/* eslint-disable */
import moment from 'moment'

export default {
  name: "ReceiptingModal",
  props: {
    businessDetails: {
      type: Object,
      required: true
    },
    entry: {
      type: Object,
      required: true
    },
    billDetail: {
      type: Object,
      required: true
    },
    statuses: {
      type: Array,
      default: () => []
    },
    subCounties: {
      type: Array,
      default: () => []
    },
    subCounty: {
      type: Object,
      default: () => ({})
    },
    wards: {
      type: Array,
      default: () => []
    },
    ward: {
      type: Object,
      default: () => ({})
    },
    zones: {
      type: Array,
      default: () => []
    },
    zone: {
      type: String,
      default: ''
    },
    floors: {
      type: Array,
      default: () => []
    },
    floor: {
      type: Object,
      default: () => ({})
    },
    tradeCategories: {
      type: Array,
      default: () => []
    },
    tradeCategory: {
      type: Object,
      default: () => ({})
    },
    tradeSubCategories: {
      type: Array,
      default: () => []
    },
    tradeSubCategory: {
      type: Object,
      default: () => ({})
    },
    tradeSubCategoriesOther: {
      type: Array,
      default: () => []
    },
    checkedItems: {
      type: Array,
      default: () => []
    },
    totalFeeAmount: {
      type: Number,
      default: 0
    },
    validationAction: {
      type: String,
      default: 'approve'
    },
    archiveReason: {
      type: String,
      default: ''
    },
    otherReason: {
      type: String,
      default: ''
    },
    remarks: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    penalized: {
      type: Boolean,
      default: false
    },
    // NEW: Props for loading state
    isDataLoading: {
      type: Boolean,
      default: false
    },
    selectedFiscalYear: {
      type: Number,
      default: null
    },
    fiscalYearOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      localBusinessDetails: { ...this.businessDetails },
      localSubCounty: { ...this.subCounty },
      localWard: { ...this.ward },
      localZone: this.zone,
      localFloor: { ...this.floor },
      localTradeCategory: { ...this.tradeCategory },
      localTradeSubCategory: { ...this.tradeSubCategory },
      localCheckedItems: [...this.checkedItems],
      localValidationAction: this.validationAction,
      localArchiveReason: this.archiveReason,
      localOtherReason: this.otherReason,
      localRemarks: this.remarks,
      localPenalized: this.penalized,
      // Guard flags to prevent infinite loops
      isUpdatingFromProp: false,
      // Loading states for buttons
      loadingUpdate: false,
      loadingInvoice: false,
      // Modal element reference
      modalElement: null
    }
  },
  computed: {
    invoicingYear() {
      return this.selectedFiscalYear || Number(this.entry.year) + 1;
    },
    mapUrl() {
      const encodedBusinessName = encodeURIComponent(this.localBusinessDetails.businessName || '');
      return `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d46449.71551863634!2d${this.localBusinessDetails.lng || 0}!3d${this.localBusinessDetails.lat || 0}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f0cb9ff59a4a3%3A0x4073419e11826405!2s${encodedBusinessName}!5e0!3m2!1sen!2ske!4v1691859398886!5m2!1sen!2ske`;
    },
    computedTotalFeeAmount() {
      return this.localCheckedItems.reduce((sum, item) => sum + parseFloat(item.unitFeeAmount || 0), 0);
    },
    computedGrandTotal() {
      const mainFee = parseFloat(this.localTradeSubCategory.unitFeeAmount || 0);
      const additionalFees = this.computedTotalFeeAmount;
      return mainFee + additionalFees;
    },
    // Check if all required data is loaded
    isDataReady() {
      // Check if essential data is present
      const hasBusinessDetails = this.localBusinessDetails && this.localBusinessDetails.businessName;
      const hasTradeCategory = this.localTradeCategory && this.localTradeCategory.incomeTypeId;
      const hasTradeSubCategory = this.localTradeSubCategory && this.localTradeSubCategory.feeId;
      const hasSubCounties = this.subCounties && this.subCounties.length > 0;
      const hasTradeCategories = this.tradeCategories && this.tradeCategories.length > 0;

      return hasBusinessDetails && hasTradeCategory && hasTradeSubCategory && hasSubCounties && hasTradeCategories;
    }
  },
  mounted() {
    // Get modal element and listen for hidden event
    this.$nextTick(() => {
      this.modalElement = document.querySelector('.receipting-modal');
      if (this.modalElement) {
        this.modalElement.addEventListener('hidden.bs.modal', this.onModalHidden);
      }
    });
  },
  beforeUnmount() {
    // Clean up event listener
    if (this.modalElement) {
      this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden);
    }
  },
  // Vue 2 compatibility
  beforeDestroy() {
    if (this.modalElement) {
      this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden);
    }
  },
  watch: {
    businessDetails: {
      handler(newVal) {
        this.isUpdatingFromProp = true;
        this.localBusinessDetails = { ...newVal };
        this.$nextTick(() => { this.isUpdatingFromProp = false; });
      },
      deep: true
    },
    subCounty: {
      handler(newVal) {
        this.isUpdatingFromProp = true;
        this.localSubCounty = { ...newVal };
        this.$nextTick(() => { this.isUpdatingFromProp = false; });
      },
      deep: true
    },
    ward: {
      handler(newVal) {
        this.isUpdatingFromProp = true;
        this.localWard = { ...newVal };
        this.$nextTick(() => { this.isUpdatingFromProp = false; });
      },
      deep: true
    },
    zone(newVal) {
      this.isUpdatingFromProp = true;
      this.localZone = newVal;
      this.$nextTick(() => { this.isUpdatingFromProp = false; });
    },
    floor: {
      handler(newVal) {
        this.isUpdatingFromProp = true;
        this.localFloor = { ...newVal };
        this.$nextTick(() => { this.isUpdatingFromProp = false; });
      },
      deep: true
    },
    tradeCategory: {
      handler(newVal) {
        this.isUpdatingFromProp = true;
        this.localTradeCategory = { ...newVal };
        this.$nextTick(() => { this.isUpdatingFromProp = false; });
      },
      deep: true
    },
    tradeSubCategory: {
      handler(newVal) {
        this.isUpdatingFromProp = true;
        this.localTradeSubCategory = { ...newVal };
        this.$nextTick(() => { this.isUpdatingFromProp = false; });
      },
      deep: true
    },
    checkedItems: {
      handler(newVal) {
        this.isUpdatingFromProp = true;
        this.localCheckedItems = [...newVal];
        this.$nextTick(() => { this.isUpdatingFromProp = false; });
      },
      deep: true
    },
    validationAction(newVal) {
      this.isUpdatingFromProp = true;
      this.localValidationAction = newVal;
      this.$nextTick(() => { this.isUpdatingFromProp = false; });
    },
    archiveReason(newVal) {
      this.isUpdatingFromProp = true;
      this.localArchiveReason = newVal;
      this.$nextTick(() => { this.isUpdatingFromProp = false; });
    },
    otherReason(newVal) {
      this.isUpdatingFromProp = true;
      this.localOtherReason = newVal;
      this.$nextTick(() => { this.isUpdatingFromProp = false; });
    },
    remarks(newVal) {
      this.isUpdatingFromProp = true;
      this.localRemarks = newVal;
      this.$nextTick(() => { this.isUpdatingFromProp = false; });
    },
    penalized(newVal) {
      this.isUpdatingFromProp = true;
      this.localPenalized = newVal;
      this.$nextTick(() => { this.isUpdatingFromProp = false; });
    },
    loading(newVal) {
      if (!newVal) {
        this.loadingUpdate = false;
        this.loadingInvoice = false;
      }
    },
    localBusinessDetails: {
      handler(newVal) {
        if (!this.isUpdatingFromProp) {
          this.$emit('update:businessDetails', newVal);
        }
      },
      deep: true
    },
    localSubCounty: {
      handler(newVal) {
        if (!this.isUpdatingFromProp) {
          this.$emit('update:subCounty', newVal);
        }
      },
      deep: true
    },
    localWard: {
      handler(newVal) {
        if (!this.isUpdatingFromProp) {
          this.$emit('update:ward', newVal);
          this.localBusinessDetails.wardName = newVal.wardName;
          this.localBusinessDetails.wardID = newVal.wardID;
        }
      },
      deep: true
    },
    localZone(newVal) {
      if (!this.isUpdatingFromProp) {
        this.$emit('update:zone', newVal);
        this.localBusinessDetails.zone = newVal;
      }
    },
    localFloor: {
      handler(newVal) {
        if (!this.isUpdatingFromProp) {
          this.$emit('update:floor', newVal);
        }
      },
      deep: true
    },
    localTradeCategory: {
      handler(newVal) {
        if (!this.isUpdatingFromProp) {
          this.$emit('update:tradeCategory', newVal);
        }
      },
      deep: true
    },
    localTradeSubCategory: {
      handler(newVal) {
        if (!this.isUpdatingFromProp) {
          this.$emit('update:tradeSubCategory', newVal);
        }
      },
      deep: true
    },
    localCheckedItems: {
      handler(newVal) {
        if (!this.isUpdatingFromProp) {
          this.$emit('update:checkedItems', newVal);
        }
      },
      deep: true
    },
    localValidationAction(newVal) {
      if (!this.isUpdatingFromProp) {
        this.$emit('update:validationAction', newVal);
      }
    },
    localArchiveReason(newVal) {
      if (!this.isUpdatingFromProp) {
        this.$emit('update:archiveReason', newVal);
      }
    },
    localOtherReason(newVal) {
      if (!this.isUpdatingFromProp) {
        this.$emit('update:otherReason', newVal);
      }
    },
    localRemarks(newVal) {
      if (!this.isUpdatingFromProp) {
        this.$emit('update:remarks', newVal);
      }
    },
    localPenalized(newVal) {
      if (!this.isUpdatingFromProp) {
        this.$emit('update:penalized', newVal);
      }
    }
  },
  methods: {
    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num);
    },
    formattedDate(date) {
      return moment(date).format('DD MMM YYYY hh:mm A') + ' (' + moment(date).fromNow() + ')';
    },
    onSubCountyChange(subCountyID) {
      this.localBusinessDetails.subCountyName = this.localSubCounty.subCountyName;
      this.localBusinessDetails.subCountyID = this.localSubCounty.subCountyID;
      this.$emit('getWards', subCountyID);
    },
    onTradeCategoryChange(incomeTypeId) {
      this.$emit('getTradeSubCategory', incomeTypeId);
    },
    onPrintBill(billNo) {
      this.$emit('printBill', billNo);
    },
    onPrintReceipt() {
      this.$emit('printReceipt');
    },
    onArchive() {
      this.$emit('archiveBusiness');
    },
    onUpdateOnly() {
      this.loadingUpdate = true;
      this.$emit('updateOnly');
    },
    onGenerateInvoice() {
      this.loadingInvoice = true;
      this.$emit('generateInvoice');
    },
    // Called when modal is closed/hidden
    onModalHidden() {
      console.log('Modal closed - resetting data');
      this.resetLocalData();
      // Emit event to parent to reset its data too
      this.$emit('modalClosed');
    },
    // Reset all local data to empty/default values
    resetLocalData() {
      this.localBusinessDetails = {};
      this.localSubCounty = {};
      this.localWard = {};
      this.localZone = '';
      this.localFloor = {};
      this.localTradeCategory = {};
      this.localTradeSubCategory = {};
      this.localCheckedItems = [];
      this.localValidationAction = 'approve';
      this.localArchiveReason = '';
      this.localOtherReason = '';
      this.localRemarks = '';
      this.localPenalized = false;
      this.loadingUpdate = false;
      this.loadingInvoice = false;
    }
  }
}
</script>

<style scoped>
.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentColor;
  opacity: 0.5;
  border-radius: 0.25rem;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
</style>